import { NODES_CONNECTABLE, SOURCE_CONNECTED, MODAL_SELECTED_VALUE, GO_BACK, SELECTED_JOURNEY, SAVE_SOLO, SELECTED_SOLO, SoloActionType, SOLO_SAVE_SUCCESS, SOLO_SERVICE, EVENTS_NODE_CONNECTION } from "./types";


export function saveSolo(data: any): SoloActionType {
    return {
        type: SAVE_SOLO,
        data: data
    }
}

export function selectedSolo(data: any): SoloActionType {
    return {
        type: SELECTED_SOLO,
        data: data
    }
}

export function soloSaveSuccess(data: any): SoloActionType {
    return {
        type: SOLO_SAVE_SUCCESS,
        data: data
    }
}

export function selectedServices(data: any): SoloActionType {
    return {
        type: SOLO_SERVICE,
        data: data
    }
}

export function isConnectable(data: any): SoloActionType {
    return {
        type: NODES_CONNECTABLE,
        data: data
    }
}

// export function goBackFromForm(data: any): SoloActionType {
//     return {
//         type: ,
//         data: data
//     }
// }

export function eventNodeConnection(data: any): SoloActionType {
    return {
        type: EVENTS_NODE_CONNECTION,
        data: data
    }
}

export function findSourceConnection(data: any): SoloActionType {
    return {
        type: SOURCE_CONNECTED,
        data: data
    }
}

export function ModalSelectedValue(data: any): SoloActionType {
    return {
        type: MODAL_SELECTED_VALUE,
        data: data
    }
}

export function selectedJourney(data: any): SoloActionType {
    return {
        type: SELECTED_JOURNEY,
        data: data
    }
}

export function GoBackFunctionality(data: any): SoloActionType {
    return {
        type: GO_BACK,
        data: data
    }
}
